import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Stack, Text, textColors } from '@etg/wings';
import { dataCellStyles } from '../utils/summaryStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cellStyles = css`
  ${dataCellStyles};

  @media (max-width: 47.9375em) {
    display: block;
    margin-left: 36px;
    max-width: 43%;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 36px;
    }
  }
`;
const SummaryPriceCellWithPriceBreakdown = _ref => {
  let {
    carrier,
    markup,
    seatPrice
  } = _ref;
  const {
    t
  } = useTranslation();
  if (typeof seatPrice !== 'number') {
    return /*#__PURE__*/_jsx("td", {});
  }
  const normalizedMarkup = markup !== null && markup !== void 0 ? markup : 0;
  const providerPrice = priceUtils.formatPrice(seatPrice - normalizedMarkup);
  const markupPrice = priceUtils.formatPrice(normalizedMarkup);
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 0,
      children: [/*#__PURE__*/_jsx(Text, {
        children: `${t('Product.SeatMap.Seat.Price')} ${priceUtils.formatPrice(seatPrice)}`
      }), Boolean(carrier.name) && /*#__PURE__*/_jsx(Text, {
        as: "bdi",
        color: textColors.SECONDARY,
        children: t('Product.Carrier.PriceBreakdown.Text', `${carrier.name} ${providerPrice}`, `${t('Product.Markup.Label')} ${markupPrice}`)
      })]
    })
  });
};
export default SummaryPriceCellWithPriceBreakdown;
//# sourceMappingURL=SummaryPriceCellWithPriceBreakdown.js.map